export const types = {
  SHOW_NMoT: 'SHOW_NMoT',
  CANCEL_NMoT: 'CANCEL_NMoT',
  SET_NMoT: 'SET_NMoT',
  UNSET_NMoT: 'UNSET_NMoT',
}